import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useBorrowRateStyle } from './BorrowRate.style';
import { BorrowAmountFields } from '../BorrowAmount';

import { useGetBorrowRate } from '@/shared/hooks/useGetBorrowRate';
import { useCalculateCollateralPrices } from '@/shared/hooks/useCalculateCollateralPrices';
import { Agreement } from '@/shared/api/borrow';
import { Skeleton } from '@/shared/ui';

type BorrowRateProps = {
    agreement: Agreement;
    collateralStressTested: string | null;
    collateralMarketValue: string | null;
    agreementAddress: string;
};

const BorrowRate = ({
    agreement,
    collateralStressTested,
    collateralMarketValue,
    agreementAddress,
}: BorrowRateProps) => {
    const classes = useBorrowRateStyle();

    const { watch } = useFormContext();

    const borrowAmount = watch(BorrowAmountFields.ASSET_AMOUNT);

    const { prices } = useCalculateCollateralPrices(
        collateralMarketValue as string,
        agreementAddress,
        agreement,
    );

    const { LTV, MAX_LTV } = useGetBorrowRate({
        agreement,
        collateralStressTested,
        borrowAmount,
        prices,
        collateralMarketValue,
    });

    return (
        <div className={classes.borrowRateWrapper}>
            <div className={classes.borrowRateItem}>
                <p className={classes.title}>LTV</p>
                <p className={classes.borrowRateValues}>
                    {LTV && LTV != 'NaN' ? `${LTV}%` : <Skeleton className={classes.micro} />}
                </p>
            </div>
            <div className={classes.borrowRateItem}>
                <p className={classes.title}>Max LTV</p>
                <p className={classes.borrowRateValues}>
                    {MAX_LTV && MAX_LTV != 'NaN' ? (
                        `${MAX_LTV}%`
                    ) : (
                        <Skeleton className={classes.micro} />
                    )}
                </p>
            </div>
            <div className={classes.borrowRateItem}>
                <p className={classes.title}>Liquidation Fee</p>
                <p className={classes.borrowRateValues}>{agreement.liquidationFee}%</p>
            </div>
        </div>
    );
};

export default BorrowRate;
